import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessengerService } from '../messenger/messenger.service';
import { EnvironmentService } from '../environment/environment.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class HelpdeskService {
  options;

  constructor(private http: HttpClient, private messengerService: MessengerService, private environmentService: EnvironmentService) {
    this.options = { headers: { 'authentication': this.messengerService.basicMessengerService.getAuthenticationHeader() } };
  }

  async createTicket(title, content) {
    return this.http.post(environment.apiBaseURL + '/helpdesk', { content, title }, this.options).toPromise();
  }
}
